<div id="friend-zone">
    <div *ngIf="gamePic;else choose" class="banner-container"
         [ngStyle]="{'background-image': 'url('+gamePic+')'}">
<div class="background-color {{gameName}}"></div>
        <div class="logo">
            <img src="assets/img/games/{{gameName}}/logo.png" alt="">
        </div>
        <h1>" {{gameText}} "</h1>
        <!--<img class="img-responsive" src={{gamePic}} alt="{{gamePic}} Tournaments">-->
    </div>


    <ng-template #choose>


        <div class="mobile-banner hidden-lg hidden-md">

            <img  class="img-responsive" src="assets/img/friend-zone/friend-banner-mobile.jpg" alt="">

            <div class="text">
                <img src="assets/img/friend-zone/friend-zone-icon.png" style="border-radius: 180px;" width="80" alt="">
                <h1>Welcome to the Friend Zone</h1>
                <p>We don't have a valentine in here, You still in the zone, grab your <b>CONTROLLER, PHONE, and
                    MOUSE</b> and get ready.</p>
                <p style="text-transform: uppercase; font-family: proxima-nova-bold-webfont;">forever in love with the
                    game.</p>

                <div class="go_button friend-zone sm square" (click)="multidialog('share-friend-zone')">
                    <i class="icon-share">Share</i>
                </div>
            </div>
        </div>

    <div class="friend-zone-banner hidden-sm hidden-xs">

            <div (click)="chooseGame('fortnite')"  class="character-container l ">
                <div class="background-color fortnite"></div>
                <div class="logo">
                    <img src="assets/img/games/fortnite/logo.png" alt="">
                </div>
                <div class="character-background">
                    <img src="assets/img/friend-zone/characters/fortnite.jpg" alt="">
                </div>
            </div>


            <div (click)="chooseGame('pubg-lite')" class="character-container l ">
                <div class="background-color pubg-lite"></div>
                <div class="logo l">
                    <img src="assets/img/games/pubg-lite/logo.png" alt="">
                </div>
                <div class="character-background">
                    <img src="assets/img/friend-zone/characters/pubg-lite-face.jpg" alt="">
                </div>
            </div>

            <div class="text">
                <img src="assets/img/friend-zone/friend-zone-icon.png" style="border-radius: 180px;" width="80" alt="">
                <h1>Welcome to the Friend Zone</h1>
                <p>We don't have a valentine in here, You still in the zone, grab your <b>CONTROLLER, PHONE, and
                    MOUSE</b> and get ready.</p>
                <p style="text-transform: uppercase; font-family: proxima-nova-bold-webfont;">forever in love with the
                    game.</p>
                <div class="go_button friend-zone sm square" (click)="multidialog('share-friend-zone')">
                    <i class="icon-share">Share</i>
                </div>

            </div>


            <div (click)="chooseGame('rainbow-six-siege')" class="character-container r">
                <div class="background-color rainbow-six-siege"></div>
                <div class="logo r">
                    <img src="assets/img/games/rainbow-six-siege/logo.png" alt="">
                </div>
                <div class="character-background">
                    <img src="assets/img/friend-zone/characters/rainbow-six-siege.jpg" alt="">
                </div>
            </div>


            <div (click)="chooseGame('league-of-legends')" class="character-container r">
                <div class="background-color league-of-legends"></div>
                <div class="logo r">
                    <img src="assets/img/games/league-of-legends/logo.png" alt="">
                </div>
                <div class="character-background">
                    <img src="assets/img/friend-zone/characters/league-of-legends.jpg" alt="">
                </div>
            </div>


            <div (click)="chooseGame('pubg')">
                <div class="character-container r">
                    <div class="background-color pubg"></div>
                    <div class="logo r">
                        <img src="assets/img/games/pubg/logo.png" alt="">
                    </div>
                    <div class="character-background">
                        <img src="assets/img/friend-zone/characters/pubg.jpg" alt="">
                    </div>
                </div>
            </div>
    </div>
    </ng-template>


    <div *ngIf="gamePic" class="tournaments-title-bar">
        <div class="icon" (click)="chooseGame('')">
        <i class="item glyphicon glyphicon-chevron-left"></i>
        </div>

    </div>

    <div class="container" *ngIf="!gamePic">
        <!--<div class="friend-zoneLights"></div>-->
        <h1 style="font-family:proxima-nova-bold-webfont; text-align: center; text-transform: uppercase; color:#ff4771;
margin:70px 10px 50px 10px;">How to get out of the zone</h1>
        <div class="steps">
            <div class="item">
                <div class="icon">
                    <p>1</p>
                </div>
                <img src="assets/img/friend-zone/sweatpants-icon.svg" alt="">

                <h1>Wear your sweatpants</h1>
            </div>

            <div class="item">
                <div class="icon">
                    <p>2</p>
                </div>
                <img src="assets/img/friend-zone/room.svg" alt="">
                <h1>Go to your room</h1>
            </div>

            <div class="item">
                <div class="icon">
                    <p>3</p>
                </div>
                <img src="assets/img/friend-zone/light-switch.svg" alt="">
                <h1>Turn off the lights</h1>
            </div>
        </div>

        <div class="steps">
            <div class="item2">
                <div class="icon">
                    <p>4</p>
                </div>
                <img src="assets/img/friend-zone/game-controller.svg" alt="">
                <h1>Now Choose Your Valentine</h1>
            </div>
        </div>

    </div>
  <div class="container">
    <div class="row">
      <router-outlet></router-outlet>
    </div>
  </div>

    <perfect-scrollbar class="games-container"  *ngIf="!gamePic">
        <div class="container">
        <div class="flex_block" style="height:400px; align-items: center">
            <div class="games_block" routerLink="./{{game}}" routerLinkActive="active" *ngFor="let game of games"
                 [ngStyle]="{'background-image': 'url(assets/img/friend-zone/games/'+game+'/character.jpg)'}">
                <div class="background-color {{game}}"></div>
                <img src="assets/img/games/{{game}}/logo.png" width="120" alt="" style="z-index: 1">

            </div>
        </div>
        </div>
        <!--<div class="cliped-circle-container">-->
        <!--<a class="cliped-circle" routerLink="./{{game}}" routerLinkActive="active" *ngFor="let game of games">-->
        <!--<div class="friend-zone_wreath"></div>-->
        <!--<div class="circle-background"-->
        <!--[ngStyle]="{'background-image': 'url(assets/img/friend-zone/games/'+game+'/sm.jpg)'}"></div>-->
        <!--<img src="assets/img/games/{{game}}/logo.png" width="80" alt="" style="z-index: 1">-->
        <!--</a>-->
        <!--</div>-->


        <!-- Happy Valentines day Codepen! -->
        <!--<div class="bgoverlay">-->
            <!--<div class="container">-->
    <!--<span class="ico">-->
      <!--<span class="ico2"></span>-->
      <!--<span class="title">Click Me</span>-->
    <!--</span>-->
                <!--<div class="endtext">-->
                    <!--<span class="close" title="Restart"><i class="fa fa-times"></i></span>-->
                    <!--<h1>I love you baby</h1>-->
                    <!--<h2>Be my valentine?</h2>-->
                    <!--<h3>~Skippy</h3>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->

    </perfect-scrollbar>




    <!--footer-->
    <div class="friend-zone_footer">
        <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/GBarena-type.svg"
                                                                               style="width: 80px"
                                                                               alt="GBarena Logo"></a>

        <p>friend-zone Event is hosted and powered by GBarena, <br> All Terms & Conditions Apply </p>

    </div>
</div>
